import { useEffect, useContext } from "react";
import useFetch from "../../../components/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../store/AuthContext";
import {
  CHECK_RESET_SENHA,
  MEUCORREIOS_PESQUISA,
} from "../../../services/meuCorreios";
import { PESQUISAR_CONTRATOS_PJ } from "../../../services/delegacao";

const TelaPrincipal = () => {
  const { user, logout, resetSenha } = useContext(AuthContext);
  const navigate = useNavigate();
  const { request: requestMeuCorreios, data: dadosUsuario } = useFetch();
  const idCorreios = user?.sub;
  const { request: requestContrato, data: dadosContrato } = useFetch();
//  const { request: requestCheckReset, data: dadosCheckReset } = useFetch();
/*
  useEffect(() => {
    if (idCorreios && idCorreios != "") {
      requestCheckReset(CHECK_RESET_SENHA(idCorreios));
    } else {
      navigate("/login");
    }
  }, [idCorreios]);
*/
  useEffect(() => {
//    if (dadosCheckReset) {
/*      if (dadosCheckReset.senhaExpirada === true) {
        navigate("/redefinir-senha-obrigatoria");
        return;
      }
*/
//    }
    requestMeuCorreios(MEUCORREIOS_PESQUISA(idCorreios));
    
  }, [idCorreios]);

  useEffect(() => {
    if (dadosContrato) {
      // Se válido, prosseguir para a tela principal PJ
      const dados = [dadosUsuario, dadosContrato];
      navigate("/principalPJ", { state: dados });
    }
  }, [dadosContrato]);

  useEffect(() => {
    if (dadosUsuario) {
      if (dadosUsuario.situacaoAtual === "R") {
        navigate("/recadastramento", { state: dadosUsuario });
      } else {
        // Verificar senha expirada para PJ
        if (dadosUsuario.tipo === "PJ") {
          if (dadosUsuario.senhaExpirada === true) {
            resetSenha();
            return;
          }
          requestContrato(PESQUISAR_CONTRATOS_PJ(idCorreios, "PJ"));

        } else {
          navigate("/principalPF", { state: dadosUsuario });
        }
      }
    } /*else {
      abreAlertaDialog('Usuário não cdastrado no MeuCorreios.');
      logout();
    }*/
  }, [dadosUsuario]);
  return <></>;
};
export default TelaPrincipal;
